/**
 * Hilfsfunktion, die einen Pfad zu einem Bild in den Assets zurückgibt
 * 
 * @param imagePath Der relative Pfad zum Bild im Assets-Verzeichnis
 * @returns Die vollständige URL zum Bild
 */
export function getImageAssetPath(imagePath: string): string {
  // In der Entwicklungsumgebung
  if (import.meta.env.DEV) {
    // Korrekter relativer Pfad zum Asset
    return `/src/assets/images/${imagePath}`;
  }
  
  // In der Produktionsumgebung
  // (Vite packt Assets in den Assets-Ordner und versieht sie mit Hashes)
  return new URL(`../assets/images/${imagePath}`, import.meta.url).href;
} 